"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var EmailAlert = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M19.5,10.3 C21.598682,10.3 23.3,8.59868205 23.3,6.5 C23.3,4.40131795 21.598682,2.7 19.5,2.7 C17.401318,2.7 15.7,4.40131795 15.7,6.5 C15.7,8.59868205 17.401318,10.3 19.5,10.3 Z M19.5,11 C17.0147186,11 15,8.98528137 15,6.5 C15,4.01471863 17.0147186,2 19.5,2 C21.9852814,2 24,4.01471863 24,6.5 C24,8.98528137 21.9852814,11 19.5,11 Z M19,4 L20,4 L20,7 L19,7 L19,4 Z M19,8 L20,8 L20,9 L19,9 L19,8 Z M14.7703908,9.96684044 L15.393965,10.749426 L12.9761871,12.8218071 C12.4144525,13.3032939 11.5855475,13.3032939 11.0238129,12.8218071 L5,7.65853889 L5,17 L19,17 L19,13 L20,13 L20,17 C20,17.5522847 19.5522847,18 19,18 L5,18 C4.44771525,18 4,17.5522847 4,17 L4,7 C4,6.44771525 4.44771525,6 5,6 L13,6 L13,7 L5.76829537,7 L11.6746043,12.0625505 C11.8618492,12.2230461 12.1381508,12.2230461 12.3253957,12.0625505 L14.7703908,9.96684044 Z" })));
};
EmailAlert.displayName = 'EmailAlert';
exports.default = EmailAlert;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=EmailAlert.js.map